<template>
  <div>
    <HeaderLandingPage @scroll-subscription="scrollToPlan" />
    <br />
    <div class="title">
      <h1 data-aos="fade-right" data-aos-duration="2000">
        <p>{{ $t('sloganMain1') }}</p>
        <!-- <p>{{ $t('sloganMain2') }}</p> -->
      </h1>
    </div>
    <br />
    <div id="useCase"></div>
    <br />
    <div class="subtitle">{{ $t('useCases') }}</div>
    <UseCase />
    <br />
    <div id="features"></div>
    <br />
    <div class="subtitle">{{ $t('features') }}</div>
    <Features />
    <br />
    <FreeBanner />
    <br />
    <div class="container" id="pricingTable">
      <PricingTable @subscription-data="saveSubscriptionDetails" />
      <br />
      <div id="FAQ"></div>
      <br />
      <div>
        <FAQ />
      </div>
      <FooterLandingPage />
      <CookieNotice />
    </div>
    <b-modal id="register-modal" size="xl" hide-footer static>
      <template v-slot:modal-title> </template>
      <RegisterClient
        :from="'landing-page'"
        @account-created="addSubscriptionPlan"
        @open-login="openLoginModal"
      />
    </b-modal>
    <b-modal id="login-modal" size="xl" hide-footer static>
      <template v-slot:modal-title> </template>
      <LoginNonUsers 
      :from="'landing-page'"
      ref="loginNonUsers"
     />
    </b-modal>
  </div>
</template>

<script>
import HeaderLandingPage from '@/components/landingPage/HeaderLandingPage.vue'
import UseCase from '@/components/landingPage/UseCase.vue'
import Features from '@/components/landingPage/Features.vue'
import FreeBanner from '@/components/landingPage/FreeBanner.vue'
import PricingTable from '@/components/landingPage/PricingTable.vue'
import FooterLandingPage from '@/components/landingPage/FooterLandingPage.vue'
import FAQ from '@/components/landingPage/FAQ.vue'
import RegisterClient from '@/components/ui/RegisterClient.vue'
import CookieNotice from '@/components/layout/CookieNotice.vue'
import LoginNonUsers from '../pages/LoginNonUsers.vue'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('sloganGuest'),
	  meta: [
        {
          vmid: this.$i18n.t('sloganGuest'),
          name: this.$i18n.t('description1'),
          content: this.$i18n.t('description')
        }
      ]
    }
  },
  components: {
    HeaderLandingPage,
    UseCase,
    Features,
    FreeBanner,
    PricingTable,
    FooterLandingPage,
    FAQ,
    RegisterClient,
    CookieNotice,
    LoginNonUsers,
  },
  data() {
    return {
      planDetails: null,
    }
  },
  methods: {
    openLoginModal() {
      this.$gtag.event('open-login-modal', { method: 'Google' })
      this.$bvModal.hide('register-modal')
      this.$bvModal.show('login-modal')
    },
    scrollToPlan() {
      const el = this.$el.getElementsByClassName('container')[0]
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    async addSubscriptionPlan(email) {
      await this.$store.dispatch('insertSubscriptionDetails', {
        ...this.planDetails,
        email: email,
      })
      this.$gtag.event('add-subscription', { method: 'Google' })
      // this.$router.push({ name: 'login' })
    },
    saveSubscriptionDetails($event) {
      this.planDetails = $event
    },
    resetLoginModalErrors() {
      this.$refs.loginNonUsers.resetModalErrors()
    }
  },
  mounted() {},
}
</script>

<style lang="css" scoped>
.title {
  margin: 6em 1em;
}

.title h1 {
  font-size: 4em;
  margin-top: 2em;
}

.title h1 p {
  font-family: "Nasalization", Helvetica, Arial;  
}

.subtitle {
  color: var(--bg-superLight);
  margin-top: 1em;
  font-size: 7em;
  margin-bottom: 0.63em;
  font-weight: 900;
  text-transform: uppercase;
  font-family: "Nunito Sans", Helvetica, Arial;  
}

.container {
  max-width: 1300px;
}

@media screen and (max-width: 1100px) {
  .subtitle {
    font-size: 4em;
    margin-top: 2em;
    margin-bottom: 1em;
  }
}

@media screen and (max-width: 500px) {
  form {
    width: 100%;
  }
  .title {
    margin: 3em 1em;
  }
  .title h1 {
    font-size: 2em;
  }
  .subtitle {
    font-size: 1.8em;
    margin-top: 2em;
    margin-bottom: 1em;
  }
}

/* SMARTPHONES LANDSCAPE */
@media only screen and (min-device-width: 480px) and (max-device-width: 820px) and (orientation: landscape) {
  .title h1 {
    font-size: 2.5em;
    margin-top: 0em;
  }
  .subtitle {
    font-size: 4em;
    margin-top: 0em;
  }
}


/*iPad */
@media only screen and (device-width: 768px) {
  .subtitle {
    font-size: 4em;
    margin-top: 2em;
    margin-bottom: 1em;
  }
  .productVision {
    font-size: 3vh;
    margin: 1rem 3rem;
  }
}

@media only screen and (min-device-width: 540px) and (max-device-width: 720px){
  .subtitle {
    font-size: 2.5em;
  }
}
</style>